import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=e5bc68d2&scoped=true&"
import script from "./BaseNotification.vue?vue&type=script&lang=js&"
export * from "./BaseNotification.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotification.vue?vue&type=style&index=0&id=e5bc68d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bc68d2",
  null
  
)

export default component.exports